import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '@ld.consumer-portal/modals';
import { tourPortalIcon } from '@ld.consumer-portal/data-uri';

@Component({
  selector: 'ld-tour-welcome-modal',
  imports: [TranslocoDirective, MatProgressSpinnerModule, BaseModalComponent],
  templateUrl: './tour-welcome-modal.component.html',
  styleUrl: './tour-welcome-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourWelcomeModalComponent {
  protected readonly tourPortalIcon = tourPortalIcon;

  isLoading = input<boolean>(false);

  takeTour = output<void>();

  skipTour = output<void>();

  remindLater = output<void>();

  protected readonly loadingAction = signal<'take_tour' | 'skip_tour' | 'remind_later' | null>(null);

  private readonly loadingResetEffect = effect(() => {
    const loading = this.isLoading();
    if (!loading && this.loadingAction()) {
      this.loadingAction.set(null);
    }
  });

  protected onTakeTour(): void {
    if (this.isLoading() || this.loadingAction()) return;
    this.loadingAction.set('take_tour');
    this.takeTour.emit();
  }

  protected onSkipTour(): void {
    if (this.isLoading() || this.loadingAction()) return;
    this.loadingAction.set('skip_tour');
    this.skipTour.emit();
  }

  protected onRemindLater(): void {
    if (this.isLoading() || this.loadingAction()) return;
    this.loadingAction.set('remind_later');
    this.remindLater.emit();
  }

  resetLoading(): void {
    this.loadingAction.set(null);
  }
}
